import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import {AlertAction} from '../Actions/Models/AlertActionModel';
import * as Types from 'Models/AlertModel';
import * as AlertModule from 'Modules/AlertModule';

export type State = Types.AlertStore;
export const initialState: State = {
    alertDefinitions: null,
    activeAlert: null,
    manageCars: [],
    manageCarsIds: [],
    manageFleets: [],
    manageFleetsIds: [],
    manageDomainOfIntrest: [],
    manageDomainOfIntrestIds: [],
    alertDefinitionGroupped: {
        LOW: [],
        MEDIUM: [],
        HIGH: []
    },
    alertHistoryLog: null,
    activeHistoryAlert: null
};

export function alertReducer(state: State = initialState, action: AlertAction): State {
    switch (action.type) {
        case ActionTypes.ALERT.GET_USER_ALERTS:
            const {LOW, MEDIUM, HIGH} = AlertModule.EnumTypes.Priority;

            const alertDefinitionGroupped: Types.PriorityModel = {
                LOW: [],
                MEDIUM: [],
                HIGH: []
            };
            action.payload.alertDefinitions.forEach((alertDTO, idx) => {
                switch (alertDTO.priority) {
                    case LOW:
                        alertDefinitionGroupped.LOW.push(alertDTO);
                        break;
                    case MEDIUM:
                        alertDefinitionGroupped.MEDIUM.push(alertDTO);
                        break;
                    case HIGH:
                        alertDefinitionGroupped.HIGH.push(alertDTO);
                        break;
                    default:
                        break;
                }
            });
            return {
                ...state,
                alertDefinitions: action.payload.alertDefinitions,
                alertDefinitionGroupped
            };

        case ActionTypes.ALERT.SET_ACTIVE_ALERT:
            return {
                ...state,
                activeAlert: action.payload.activeAlert,
                manageCars: action.payload.activeAlert ? [...action.payload.activeAlert.cars] : [],
                manageCarsIds: action.payload.activeAlert ? [...action.payload.activeAlert.cars.map((e, i) => e.id)] : [],
                manageFleets: action.payload.activeAlert ? [...action.payload.activeAlert.fleets] : [],
                manageFleetsIds: action.payload.activeAlert ? [...action.payload.activeAlert.fleets.map((e, i) => e.id)] : [],
                manageDomainOfIntrest: action.payload.activeAlert ? [...action.payload.activeAlert.domainsOfInterest] : [],
                manageDomainOfIntrestIds: action.payload.activeAlert ? [...action.payload.activeAlert.domainsOfInterest.map((e, i) => e.id)] : []
            };

        case ActionTypes.ALERT.SET_ACTIVE_HISTORY_ALERT:
            return {
                ...state,
                activeHistoryAlert: action.payload.activeHistoryAlert
            };

        case ActionTypes.ALERT.MANAGE_CARS:
            const {type, car} = action.payload;
            const manageCarsClone = [...state.manageCars];
            const manageCarIdsClone = [...state.manageCarsIds];
            if (type === 'ADD') {
                const checkIfContains = manageCarsClone.findIndex(e => e.id === car.id);
                if (checkIfContains === -1) {
                    manageCarsClone.push(car);
                    manageCarIdsClone.push(car.id);
                }
            } else {
                const carIdToRemove = manageCarsClone.findIndex(carDto => {
                    return carDto.id === car.id;
                });
                manageCarIdsClone.splice(carIdToRemove, 1);
                manageCarsClone.splice(carIdToRemove, 1);
            }
            return {
                ...state,
                manageCars: manageCarsClone,
                manageCarsIds: manageCarIdsClone
            };

        case ActionTypes.ALERT.MANAGE_FLEETS:
            const {type: fleetManageType, fleet} = action.payload;
            const manageFleetClone = [...state.manageFleets];
            const manageFleetIdsClone = [...state.manageFleetsIds];
            if (fleetManageType === 'ADD') {
                const checkIfContains = manageFleetClone.findIndex(e => e.id === fleet.id);
                if (checkIfContains === -1) {
                    manageFleetClone.push(fleet);
                    manageFleetIdsClone.push(fleet.id);
                }
            } else {
                const fleetIdToRemove = manageFleetClone.findIndex(fleetDTO => {
                    return fleetDTO.id === fleet.id;
                });
                manageFleetClone.splice(fleetIdToRemove, 1);
                manageFleetIdsClone.splice(fleetIdToRemove, 1);
            }
            return {
                ...state,
                manageFleets: manageFleetClone,
                manageFleetsIds: manageFleetIdsClone
            };
        case ActionTypes.ALERT.MANAGE_DOMAIN_OF_INTREST:
            const {type: manageDomainOfIntrestType, domainOfIntrest} = action.payload;
            const manageDomainOfIntrestClone = [...state.manageDomainOfIntrest];
            const manageDomainOfIntrestIdsClone = [...state.manageDomainOfIntrestIds];
            if (manageDomainOfIntrestType === 'ADD') {
                const checkIfContains = manageDomainOfIntrestClone.findIndex(e => e.id === domainOfIntrest.id);
                if (checkIfContains === -1) {
                    manageDomainOfIntrestClone.push(domainOfIntrest);
                    manageDomainOfIntrestIdsClone.push(domainOfIntrest.id);
                }
            } else {
                const fleetIdToRemove = manageDomainOfIntrestClone.findIndex(domain => {
                    return domain.id === domainOfIntrest.id;
                });
                manageDomainOfIntrestClone.splice(fleetIdToRemove, 1);
                manageDomainOfIntrestIdsClone.splice(fleetIdToRemove, 1);
            }
            return {
                ...state,
                manageDomainOfIntrest: manageDomainOfIntrestClone,
                manageDomainOfIntrestIds: manageDomainOfIntrestIdsClone
            };
        case ActionTypes.ALERT.GET_HISTORY_LOG:
            return {
                ...state,
                alertHistoryLog: action.payload.alertHistoryLogPaginatedList
            };
        case ActionTypes.ALERT.CLEAR_HISTORY_LOG:
            return {
                ...state,
                alertHistoryLog: null
            };
        case ActionTypes.ALERT.ENABLE_ALERT:
            const alertDefinitions = [...state.alertDefinitions];
            const indx = alertDefinitions.findIndex((alert, i) => alert.id === action.payload.alertId);
            alertDefinitions[indx].enabled = true;
            return {
                ...state,
                alertDefinitions
            };
        case ActionTypes.ALERT.DISABLE_ALERT:
            const alertDefinitionsCopy = [...state.alertDefinitions];
            const alertIdx = alertDefinitionsCopy.findIndex((alert, i) => alert.id === action.payload.alertId);
            alertDefinitionsCopy[alertIdx].enabled = false;
            return {
                ...state,
                alertDefinitions: alertDefinitionsCopy
            };
        case ActionTypes.ALERT.CREATE_ALERT:
        case ActionTypes.ALERT.UPDATE_ALERT:
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/AlertReducer.ts